"use strict";
exports.__esModule = true;
var utils_1 = require("../utils");
function allTogether() {
    var config = {
        delay: 10,
        nb: 100
    };
    var stopped;
    var doneCallback = null;
    function allTogetherStrategy(gremlins, params, done) {
        var nb = params && params.nb ? params.nb : config.nb;
        var horde = this;
        stopped = false;
        doneCallback = done;
        function executeAllGremlins(callback) {
            utils_1.executeInSeries(gremlins, [], horde, callback);
        }
        function executeNextWave(i) {
            if (stopped) {
                return;
            }
            if (i >= nb) {
                return callDone();
            }
            executeAllGremlins(function () {
                return setTimeout(function () { return executeNextWave(++i); }, config.delay);
            });
        }
        executeNextWave(0);
    }
    function callDone() {
        if (typeof doneCallback === "function") {
            doneCallback();
        }
        doneCallback = null;
    }
    allTogetherStrategy.stop = function () {
        stopped = true;
        setTimeout(callDone, 4);
    };
    utils_1.configurable(allTogetherStrategy, config);
    return allTogetherStrategy;
}
exports.allTogether = allTogether;
